import axios from 'axios';
import authHeader from '@/services/auth-header';
import apiHeader from '@/services/api-header';
import authHeaderQueue from '@/services/auth-header-queue';
import authHeaderQueueJson from '@/services/auth-header-queue-json';
import laravelApiClient from './laravel-api-client';

export default {
  integrateUseme(integrationData) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/user/payouts/integrate`,
      headers: apiHeader(),
      data: {
        ...integrationData,
        platform: 'useme',
      },
    });
  },
  updateBilling(userData) {
    return axios({
      method: 'PUT',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/user/me/billing`,
      headers: apiHeader(),
      data: userData,
    });
  },
  updateGlobalSaleSettings(data) {
    return axios({
      method: 'PUT',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/user/me/sales/global`,
      headers: apiHeader(),
      data: data,
    });
  },
  updateEventPhotoSettings(data) {
    return axios({
      method: 'PUT',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/user/me/sales/event`,
      headers: apiHeader(),
      data: data,
    });
  },
  updatePhotographerProfile(data) {
    return axios({
      method: 'PUT',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/user/me/sales/profile`,
      headers: apiHeader(),
      data: data,
    });
  },
  getCountries() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/wc/v3/data/countries`,
      headers: authHeader(),
    });
  },
  userRegistration(userData) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/register`,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
      },
      data: userData,
    });
  },
  registerPhotographerByOrganizer(userData) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/organizer/photographers`,
      headers: authHeader(),
      data: userData,
    });
  },
  sendResetLink(email) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/user/reset-password/request`,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      data: { email },
    });
  },
  resetPassword(email, key, newPassword, newPasswordConfirmation) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/user/reset-password/reset`,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      data: {
        email,
        key,
        new_password: newPassword,
        new_password_confirmation: newPasswordConfirmation,
      },
    });
  },
  // add-image select endpoints
  getSelectCities() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/wp/v2/cities?per_page=100`,
      headers: authHeader(),
    });
  },
  getSelectCountries() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/wp/v2/countries?per_page=100`,
      headers: authHeader(),
    });
  },
  fetchEvents(page = 1, perPage = 20, startDate) {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/events`,
      headers: authHeader(),
      params: {
        page,
        perPage,
        startDate,
      },
    });
  },
  fetchReferralEvents(page = 1, perPage = 20, startDate) {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/public-events`,
      headers: authHeader(),
      params: {
        flat: true,
        page,
        perPage,
        startDate,
      },
    });
  },
  editEmail(userId, email) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/wp/v2/users/${userId}`,
      headers: authHeader(),
      data: {
        email: email,
      },
    });
  },
  getNavbarOptions(lang) {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/menu/main/${lang}`,
      headers: authHeader(),
    });
  },
  getUserWallet() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/author/wallet`,
      headers: authHeader(),
    });
  },
  withdrawUserPayment(withdrawalAmount, currentAccountBalance) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/author/wallet/withdrawal`,
      headers: authHeader(),
      data: {
        withdrawal_amount: withdrawalAmount,
        current_account_balance: currentAccountBalance,
      },
    });
  },
  getWithdrawRequests() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/author/wallet/requests`,
      headers: authHeader(),
    });
  },
  getLanguage() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/lang/current`,
    });
  },
  getCurrencies() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/currencies`,
      headers: apiHeader(),
    });
  },
  getUserEvents() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/dashboard/races`,
      headers: apiHeader(),
    });
  },
  getEventChartDataByTimeFrame(runId, timeFrame, currency, type) {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/dashboard/races/charts`,
      headers: apiHeader(),
      params: {
        raceId: runId,
        timeFrame: timeFrame,
        currency: currency,
        type: type,
      },
    });
  },
  getEventOrdersTableData(runId, page, perPage, currency) {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/dashboard/races/orders`,
      headers: apiHeader(),
      params: {
        page: page,
        perPage: perPage,
        raceId: runId,
        currency: currency,
      },
    });
  },
  getEventDetails(runId, currency) {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/dashboard/races/details`,
      headers: apiHeader(),
      params: {
        raceId: runId,
        currency: currency,
      },
    });
  },
  createEventVerification(eventData) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/events/verifications`,
      headers: authHeader(),
      data: eventData,
    });
  },
  updateEventVerification(eventId, eventData) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/events/verifications/${eventId}`,
      headers: apiHeader(),
      data: eventData,
    });
  },
  getSingleEventVerification(eventId) {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/events/verifications/${eventId}`,
      headers: apiHeader(),
    });
  },
  getUserEventVerifications() {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/events/verifications`,
      headers: apiHeader(),
    });
  },
  deleteEventVerification(eventId) {
    return axios({
      method: 'DELETE',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/events/verifications/${eventId}`,
      headers: apiHeader(),
    });
  },
  getSingleEvent(eventId) {
    return axios({
      method: 'GET',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/events/${eventId}`,
      headers: apiHeader(),
    });
  },
  updateEvent(eventId, eventData) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_ROOT_API}/api/v1/events/${eventId}`,
      headers: apiHeader(),
      data: eventData,
    });
  },
  updateEventSponsorImage(data, eventId) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/events/${eventId}/sponsor-image`,
      headers: authHeaderQueue(),
      data: data,
    });
  },
  updateGlobalSponsorImage(data) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/user/sponsor-image`,
      headers: authHeaderQueue(),
      data: data,
    });
  },
  // LARAVEL ROUTES
  fetchRpqEvents(eventIds) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/events/eventIds`,
      headers: authHeaderQueue(),
      params: {
        ids: eventIds
      }
    });
  },
  fetchGlobalSponsorImage(wpUserId) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/user/${wpUserId}/sponsor-image`,
      headers: authHeaderQueue()
    });
  },
  fetchEventSponsorImage(eventId) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/events/${eventId}/sponsor-image`,
      headers: authHeaderQueue()
    });
  },
  userLogin(userData) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/login`,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
      data: userData,
    });
  },
  refreshToken() {
    return laravelApiClient({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/sanctum/refresh`,
    });
  },
  sendPhotoData(data, wpToken, requestOptions = {}) {
    const headers = {
      ...authHeaderQueue(),
    };

    if (wpToken) {
      headers['X-Wordpress-Token'] = wpToken;
    }

    return laravelApiClient({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/photos/bulk`,
      headers,
      data: data,
      onUploadProgress: requestOptions.onUploadProgress,
      cancelToken: requestOptions.cancelToken,
    });
  },
  sendUploadTelemetry(events) {
    const telemetryUrl = process.env.VUE_APP_UPLOAD_TELEMETRY_URL;
    if (!telemetryUrl) {
      return Promise.resolve();
    }

    return laravelApiClient({
      method: 'POST',
      url: telemetryUrl,
      headers: authHeaderQueueJson(),
      data: { events },
      timeout: 5000,
    });
  },
  sendVideoData(data) {
    return laravelApiClient({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/videos/bulk`,
      headers: authHeaderQueue(),
      data: data,
    });
  },
  getDuplicates(userId) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/photos/processed`,
      headers: authHeaderQueue(),
      params: {
        user_id: userId,
      },
    });
  },
  acceptDuplicates(userId) {
    return laravelApiClient({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/photos/processed`,
      headers: authHeaderQueue(),
      data: {
        user_id: userId,
      },
    });
  },
  getAddedPhoto(userId, page) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/photos/author`,
      headers: authHeaderQueue(),
      params: {
        wp_author_id: userId,
        page: page,
      },
    });
  },
  getToken(userData) {
    return laravelApiClient({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/sanctum/token`,
      data: userData,
    });
  },
  getUserInfo(wpToken) {
    const headers = {
      ...authHeaderQueue(),
    };
    headers['X-Wordpress-Token'] = wpToken;

    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/user`,
      headers,
    });
  },
  getEventViewsChartDataByTimeFrame(runId, timeFrame) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/dashboard/${runId}/views/timePeriod`,
      headers: authHeaderQueue(),
      params: {
        time_period: timeFrame,
      },
    });
  },
  verifyDashboardAccessByEventId(eventId) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/dashboard/${eventId}/access`,
      headers: authHeaderQueue(),
    });
  },
  getTotalPhotosInEvent(runId) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/dashboard/${runId}/totalPhotos`,
      headers: authHeaderQueue(),
    });
  },
  getAlbumViewsInEvent(runId, page, perPage, bibNumber) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/dashboard/${runId}/views`,
      headers: authHeaderQueue(),
      params: {
        page: page,
        perPage: perPage,
        runId: runId,
        bibNumber: bibNumber
      },
    });
  },
  fetchPhotographersList() {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/photographers`,
      headers: authHeaderQueue(),
    });
  },
  fetchBookingById(bookingId) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/bookings/${bookingId}`,
      headers: authHeaderQueue(),
    });
  },
  fetchAllBookings() {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/bookings`,
      headers: authHeaderQueue(),
    });
  },
  createBooking(bookingData) {
    return laravelApiClient({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/bookings`,
      headers: authHeaderQueue(),
      data: bookingData,
    });
  },
  updateBooking(bookingData, bookingId) {
    return laravelApiClient({
      method: 'PATCH',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/bookings/${bookingId}`,
      headers: authHeaderQueueJson(),
      data: bookingData,
    });
  },
  deleteBooking(bookingId) {
    return laravelApiClient({
      method: 'DELETE',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/bookings/${bookingId}`,
      headers: authHeaderQueue()
    });
  },
  payoutBooking(bookingId, wpToken) {
    const headers = {
      ...authHeaderQueue(),
    };

    headers['X-Wordpress-Token'] = wpToken;

    return laravelApiClient({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/bookings/${bookingId}/payout`,
      headers
    });
  },
  getSponsorAssets(eventId) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/events/${eventId}/sponsor-assets`,
      headers: authHeaderQueue(),
    });
  },
  updateSponsorAssets(data, eventId) {
    return laravelApiClient({
      method: 'POST',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/events/${eventId}/sponsor-assets`,
      headers: authHeaderQueue(),
      data: data,
    });
  },
  deleteSponsorAsset(sponsorAssetId) {
    return laravelApiClient({
      method: 'DELETE',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/events/sponsor-assets/${sponsorAssetId}`,
      headers: authHeaderQueue()
    });
  },
  getSponsorAssetsDashboardData(eventId) {
    return laravelApiClient({
      method: 'GET',
      url: `${process.env.VUE_APP_QUEUE_API}/api/v2/dashboard/${eventId}/sponsor-stats`,
      headers: authHeaderQueue(),
    });
  },
};
